import { SCREENS } from '../constants/TrackingConstants';
import { useGetKnowledgeBaseLimitOverage } from '../knowledge-base/hooks/knowledgeBaseHooks';
import UsageTracker from '../utils/UsageTracker';
import ActionTemporarilyDisabledTooltip from './ActionTemporarilyDisabledTooltip';
import PermissionsTooltip from './PermissionsTooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAppDispatch, useAppSelector } from '../utils/hooks';
import { createArticle } from '../actions/edit/CreateArticleActions';
import Raven from 'raven-js';
import { selectCurrentKbMigrationReport, selectCurrentKb } from '../knowledge-base/selectors/knowledgeBaseDetails';
import { isMigrationFailed } from 'knowledge-content-types/KnowledgeBaseV3Service/MigrationTypes';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CreateArticleButton = ({
  marginBlockStart
}) => {
  const canWriteArticle = useAppSelector(state => state.knowledgeScopes.canWriteArticle);
  const {
    id: currentKbId
  } = useAppSelector(selectCurrentKb);
  const kbMigration = useAppSelector(selectCurrentKbMigrationReport);
  const isMigrated = kbMigration && currentKbId === kbMigration.migration.legacyKnowledgeBaseId && !isMigrationFailed(kbMigration.migration.status);
  const isCreating = useAppSelector(state => state.createArticleRequestStatus.isCreating);
  const isCreateArticleTemporarilyDisabled = useAppSelector(state => state.disabledInteractionsConfig.isCreateArticleTemporarilyDisabled);
  const dispatch = useAppDispatch();
  const {
    isOverLimit
  } = useGetKnowledgeBaseLimitOverage();
  const handleCreateClick = () => {
    dispatch(createArticle()).catch(e => {
      Raven.captureMessage('Failed to create article', {
        extra: {
          error: e
        }
      });
    });
    UsageTracker.track('manageArticleInteraction', {
      screen: SCREENS.MANAGE,
      action: 'create-article-click'
    });
  };
  const isCreateArticleDisabled = !canWriteArticle || isCreateArticleTemporarilyDisabled || isOverLimit || isMigrated;
  const CreateButtonDisabledTooltip = isCreateArticleTemporarilyDisabled ? ActionTemporarilyDisabledTooltip : PermissionsTooltip;
  return /*#__PURE__*/_jsx(CreateButtonDisabledTooltip, {
    children: /*#__PURE__*/_jsx(LoadingButton, {
      "data-test-id": "create-article",
      disabled: isCreateArticleDisabled,
      loading: isCreating,
      onClick: handleCreateClick,
      use: "primary",
      size: "small",
      marginBlockStart: marginBlockStart,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.button.create"
      })
    })
  });
};
export default CreateArticleButton;